import React, { useEffect } from "react";
import PropTypes from "prop-types";
import { useDispatch, useSelector } from "react-redux";
import { showToast } from "../../utils/utils";
import { showToastType } from "../../utils/constants/appConstants";
import { commonErrMsg, commonText } from "../../locales/en";
import { fetchIndustryTypeData } from "../../redux/clientDetailsTabSlice";

const IndustryTypeSelect = ({
  id = "industryCategoryId",
  name = "industryCategoryId",
  value,
  onChange
}) => {
  const dispatch = useDispatch();

  const { industryTypes, industryTypesLoading } = useSelector(
    (state) => state.clientDetails
  );

  useEffect(() => {
    if (!industryTypes || industryTypes.length === 0) {
      dispatch(fetchIndustryTypeData())
        .unwrap()
        .catch((error) => {
          const errorMessages =
            error?.response?.data?.message || commonErrMsg.item2;
          showToast(errorMessages, showToastType.error);
        });
    }
  }, [dispatch, industryTypes]);

  return (
    <select
      name={name}
      id={id}
      value={value ?? ""}
      onChange={onChange}
      disabled={industryTypesLoading}
    >
      <option value="">{commonText?.select}</option>
      {(industryTypes || []).map((option) => (
        <option key={option.id} value={option.id}>
          {option.industryName}
        </option>
      ))}
    </select>
  );
};

IndustryTypeSelect.propTypes = {
  value: PropTypes.any,
  onChange: PropTypes.func.isRequired,
  name: PropTypes.string,
  id: PropTypes.string
};

export default IndustryTypeSelect;
